var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.47 36.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "highlight"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.27.81l6.39,6.39c1.02,1.02,1.09,2.66.15,3.77l-12.96,15.18-12.52-12.52L27.5.66c1.1-.94,2.74-.88,3.77.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61,17.8l2.97-2.57,12.66,12.66-2.57,2.97c-.83.95-2.17,1.27-3.33.78l-2.73-1.14-2.93,2.93-6.64-6.64,2.93-2.93-1.14-2.73c-.48-1.16-.17-2.51.78-3.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.83 36.87 0 34.23 5.11 29.12 9.34 33.36 5.83 36.87"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/Highlight.a6d5890d69b847e1cc9e250e41d28735.svg";
export { ForwardRef as ReactComponent };